import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const Clock: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M10 18C5.58172 18 2 14.4182 2 10C2 5.58172 5.58172 2 10 2C14.4182 2 18 5.58172 18 10C18 14.4182 14.4182 18 10 18ZM10.8 10V6H9.2V11.6H14V10H10.8Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default Clock;
